<template>
    <div class="leftO">
        <breadcrumb :routerList="[{to:'/xiangmu/pm',title:'项目管理'},{title:'提交报价'}]"/>
        <div style="margin:20px">
            <div class="h-row h-mrt0 ljjcommitshs" style="margin:0 -0.12rem ;">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2 ljj_tjbjs">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>询价产品信息</h1>
                                </div>
								<el-form :model="formLabelAlign" label-position="right" :inline="true" ref="formLabelAlign1" class="demo-ruleForm h-formbLine" style="margin: 0 0.1rem 0.2rem 0.2rem;">
								    <el-form-item label="项目编号" class="h-elformWrap-2" style="margin-bottom: 0;">
								        <el-input readonly v-model="formLabelAlign.id" class="h-input"></el-input>
								    </el-form-item>
									<el-form-item label="项目名称" class="h-elformWrap-2" style="margin-bottom: 0;">
									    <el-input readonly v-model="formLabelAlign.projectName" class="h-input"></el-input>
									</el-form-item>
								</el-form>
                                <!-- <div style="display: flex;margin-bottom:0.2rem">
                                    <div class="left4" style="width: 50%">
                                        <span>项目编号</span>
                                        <span class="spanT">{{formLabelAlign.id}}</span>
                                    </div>
                                    <div class="left4" style="margin-left: 0.38rem;width: 50%">
                                        <span>项目名称</span>
                                        <span class="spanT">{{formLabelAlign.projectName}}</span>
                                    </div>
                                </div> -->

                            </div>

                        </div>

                    </div>
                    <el-table
                            @selection-change="handleSelectionChange"
                            ref="multipleTable"
							:border="true"
                            :data="proProductwx"
                            style="width: 100%;margin-top: 0.2rem">
                        <el-table-column
                                type="selection"
                                width="50"
                        >
                        </el-table-column>
                        <el-table-column
                                type="index"
                                width="40"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="prodname"
                                label="产品型号"
                                min-width="120"
                                :show-overflow-tooltip="true">
								<template slot-scope="scope">
									<div style="text-align: left;">
										{{scope.row.prodname}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="proddes"
                                label="产品描述"
                                min-width="150"
                                :show-overflow-tooltip="true">
								<template slot-scope="scope">
									<div style="text-align: left;">
										{{scope.row.proddes}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="prodnum"
                                label="采购数量"
                                width="90"
                                :show-overflow-tooltip="true">
								<template slot-scope="scope">
									<div style="text-align: right;">
										{{scope.row.prodnum}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="timeOut"
                                label="报价截止时间"
                                width="120"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="unitprice"
                                label="报价"
                                width="170"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <el-input class="h-tableInput" oninput="value=value.replace(/[^\d.]/g,'')" v-model="scope.row.unitprice" placeholder="请输入"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="currency"
                                label="币种"
                                min-width="150">
                            <template slot-scope="scope">
                                <brselect category="YLCurrency"
                                              :v="scope.row.currency"
                                              v-model="scope.row.currency"
                                          class="h-tableInput">
                                </brselect>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="supprice"
                                label="总价"
                                width="90"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                {{scope.row.supprice = new big(scope.row.unitprice||0).times(scope.row.prodnum)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="priceTerm"
                                label="价格有效期"
                                width="170"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <el-date-picker
										 class="h-tableInput"
                                        v-model="scope.row.priceTerm"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        :picker-options="pickerOptions"
                                        placeholder="选择日期">
                                </el-date-picker>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="报价单"
                                width="180"
                        >
                            <template slot-scope="scope">
                                <brupload
                                        :refid=scope.row.id
                                        reftype="询价报价单附件"
                                        :showtime="false"
                                        uploadflag
                                        delflag
                                >
                                </brupload>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="查看历史报价"
                                width="120"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                    <el-button
                                            type="text"
                                            size="small"
                                            @click="gysbjhistory_click(scope.row)"
                                            class="h-tableLink h-btn" >
                                        历史报价
                                    </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="h-tableBL">
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export" @click="uploaddownexcelflagbtn">批量导入</el-button>
                        <uploaddownexcel :visible.sync="uploaddownexcelflag" v-if="uploaddownexcelflag" clsname="cgPriceImportExcel"
                                         :startrow="1" @callback="uploadExcelFilecallback" />
                    </div>
                </div>
            </div>
        </div>
        <div style="display: flex;justify-content: center;align-items: center;margin-top: 0.5rem;">
            <el-button class="el-button h-btn h-bBtn h-bgwhite" @click="goBack">返回</el-button>
            <el-button class="el-button h-btn h-bBtn h-bgblueQ2 el-button--default" @click="commitBaojia">提交</el-button>
        </div>
        <el-dialog :close-on-click-modal="false" :visible.sync="dialogTableVisible" class="h-dialog2">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>查看历史报价</h1>
                    </div>
                </div>
            </div>
            <div class="h-formLines" style="padding:30px 48px;">
                <el-table
                        :data="gridData"
						:border="true"
                        style="width: 100%">
                    <el-table-column
                            type="index"
                            width="40"
                            label="#">
                    </el-table-column>
                    <el-table-column
                            prop="supplierPrice"
                            label="报价"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="supplierTime"
                            label="时间">
                    </el-table-column>
                </el-table>
            </div>
            <div style="display:flex;justify-content:center">
                <el-button class="h-btn h-formBtn" @click="dialogTableVisible=false" type="primary">确定</el-button>
            </div>
        </el-dialog>

        <gysbjhistory :visible.sync="gysbjhistory_showflag"
                      v-if="gysbjhistory_showflag"
                      :gyscode="this.nowgyscode"
                      :proinfoid="this.proinfoid" :xmcode="this.xmcode"/>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService';
    import gysbjhistory from '../../../components/project/gysbjhistory'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel';

    export default {
        components:{
            gysbjhistory,uploaddownexcel
        },
        data() {
            return {
                uploaddownexcelflag:false,
                gysbjhistory_showflag:false,
                projectId: '',
                gridData: [],
                dialogTableVisible: false,
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
                    }
                },
                toshow: 'commit',
                nowgyscode:null,
                proinfoid:null,
                formLabelAlign: {},
                proProductwx: [],
                checkBaojialist:[],
                baojiaIdlist: [],
                proPriceOffer: {},
                subflag: 0,
                rules: {
                    unitPrice: [{required: true, message: '请输入数字', trigger: 'blur'},
                        {pattern: /^[1-9]d*|0$/, message: '只能输入正整数'}],
                    supplierPrice: [{required: true, message: '请输入数字', trigger: 'blur'},
                        {pattern: /^[1-9]d*|0$/, message: '只能输入正整数'}],
                },
                commitBaojiaData:{
                    taskid: '',
                    inquiryId: '',
                    productList: [],
                },
            }
        },
        created() {
            this.projectId = this.$route.query.ywid;
            this.query()
            this.getProdectList();
        },
        methods: {
            uploaddownexcelflagbtn(){
                this.uploaddownexcelflag=true;
            },
            uploadExcelFilecallback(rd){
                for(var i=0;i< this.proProductwx.length;i++){
                    for(var j=0;j<rd.msg.length;j++) {
                        if(this.proProductwx[i].prodid==rd.msg[j].A) {
                            this.proProductwx[i].unitprice=rd.msg[j].B;
                            this.proProductwx[i].priceTerm=rd.msg[j].C;
                            this.proProductwx[i].currency=rd.msg[j].D
                        }
                    }
                }
            },
            getProdectList() {
                ss.ProService.gysbjlistPage({xmcode:this.projectId,lastflag:0}).then(res => {
                    console.log(res, '产品列表')
                    this.proProductwx = res.obj;
                    // this.proProductwx.forEach((obj)=>{
                    //     obj.unitprice = obj.unitprice||null;
                    //     obj.supprice = obj.supprice ||null;
                    // })
                })
            },
            query() {
                ss.ProService.proDetail(this.projectId).then(rd => {
                    this.formLabelAlign = rd;
                });
            },
            handleSelectionChange(v){
                this.baojiaIdlist = [];
                for (var i = 0; i < v.length; i++) {
                    this.baojiaIdlist.push(v[i].id);
                }
                // this.checkBaojialist=v;
            },
            gysbjhistory_click(r){
                console.log(r)
                this.gysbjhistory_showflag=true;
                this.xmcode = this.projectId
                this.nowgyscode = r.supid
                this.proinfoid = r.proinfoid
            },
            zhidinggys(r){
                this.currentOpenRow = r;
                this.gysbaojiaform.xmcode = this.xmcode;
                this.gysbaojiaform.proinfoid = r.proinfoid;
                this.gysBaojiaPage();
            },
            goBack() {
                this.$router.back();
            },
            commitBaojia() {
               this.$msg.confirm("确认提交报价？",()=>{
                    // if(this.checkBaojialist.length==0){
                   this.checkBaojialist = [];
                    if(this.baojiaIdlist.length==0){
                        this.$msg.msge("至少勾选一个产品提交报价！")
                        return;
                    }
                   for (var i = 0; i < this.baojiaIdlist.length; i++) {
                       for (var j = 0; j < this.proProductwx.length; j++) {
                           if (this.baojiaIdlist[i] == this.proProductwx[j].id) {
                                if(this.proProductwx[j].currency == null || this.proProductwx[j].currency == ''){
                                    this.$msg.msge("币种不能为空！")
                                    return;
                                }
                           }
                       }
                   }
                   for (var i = 0; i < this.baojiaIdlist.length; i++) {
                       for (var j = 0; j < this.proProductwx.length; j++) {
                           if (this.baojiaIdlist[i] == this.proProductwx[j].id) {
                               this.checkBaojialist.push(this.proProductwx[j]);
                           }
                       }
                   }
                   ss.ProService.commitShanghaiBaojia(this.checkBaojialist).then(res => {
                       if (res.f){
                           this.$message({
                               type: 'success',
                               message: '提交成功!'
                           });
                           this.$router.push("/xiangmu/pmgys")
                       }
                   })
               })
            },

            cancelPro() {
                this.$router.push("/xiangmu/pmgys");
            },
            submitPro() {
                var subflag = false;
                this.$refs['proPriceOffer'].validate((valid) => {
                    if (valid) {
                        subflag = true;
                    } else {
                        this.$msg.msge("请正确填写报价后再提交！");
                        return false;
                    }
                });
                console.log(subflag);
                if (subflag) {
                    this.$msg.confirm("确认提交报价，提交后将不能再修改?", () => {
                        this.proPriceOffer.taskid = this.$route.query.taskid;
                        console.log(this.proPriceOffer);
                        ss.ProService.saveOffer(this.proPriceOffer).then(rd => {
                            this.$store.dispatch('searchTasktotal');
                            this.$msg.alerts("提交成功！", () => {
                                if (this.$route.query.taskid) {
                                    this.$router.push("/personal/dealCenter");
                                } else {
                                    this.$router.push("/xiangmu/pmgys");
                                }
                            })
                        })
                    })
                }
            },
        },

    }
</script>
<style scoped>
    .outcontain {
        display: flex;
        justify-content: space-around;
        margin-top: 0.3rem;
        padding-left: 0.3rem;
    }

    .left {
        width: 30%;
        background-color: rgb(255, 255, 255);
        height: 600px;
        border: 1px solid #E2E2E2;
    }

    .left3 {
        margin-left: 30px;
        margin-top: 20px;
    }

    .left4 span{
        font-size: 0.18rem;
        color: #4a4a4a;
        line-height: 0.28rem;
    }

    .spanT {
        margin-left: 20px;
        color: rgb(141, 140, 140);
    }

    .spanG {
        color: rgb(141, 140, 140);
    }

    hr {
        margin-top: 10px;
        height: 1px;
        background-color: rgb(222, 226, 226);
        margin-right: 20px;
    }

    .hr {
        margin-top: 20px;
    }

    hr.border {
        border: none;
    }

    .zhongbiao {
        position: relative;
        left: 15px;
    }

    .zhongbiao > div {
        padding: 5px 0;
    }

    .leftO .left .left3 .zhongbiao .el-button {
        position: relative;
        left: 90px;
        padding: 5px 10px;
        top: 25px;
        border: none;
        background-color: #d6f2e1;
        color: #34b174;
        border-radius: 6px;
    }

    span {
        font-size: 14px;
    }

    .xunjia {
        padding-top: 20px;
    }

    .right {
        width: 63%;
        height: 600px;
        background-color: rgb(255, 255, 255);
        border: 1px solid #E2E2E2;
    }

    .baojia {
        margin: 0 50px;
        padding-top: 20px;
    }

    .el-form {
        margin: 70px 0 20px 55px;
    }

    .el-form-item {
        margin-bottom: 60px;
    }

    .enter {
        margin-top: 2rem;
        display: flex;
        justify-content: center;
    }

</style>

<style>
	.ljj_tjbjs .h-formbLine .el-form-item__label {
	    width: 15% ;
	}
    .ljj_tjbjs .h-formbLine .el-form-item__content {
        width: 85%;
    }
	.ljjcommitshs .h-tableInput .el-input__inner {
	    padding: 0.05rem 0.1rem;
	}
	.ljjcommitshs .h-tableInput .el-input__icon{
		line-height: 0.25rem;
	}
</style>
<style scoped lang="scss">
    .bottomTip {
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
    }

    .newtext {
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top: 0.2rem;
        left: 0.6rem;
        font-weight: bold;
        text-shadow: 1px 1px 4px #2785E7;;
    }

    .leaderBox {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;

        .leaderbg {
            width: 100%;
            height: 100%;

        }

        .steps {
            position: absolute;
            z-index: 1;

        }

        .step1 {
            top: 3rem;
            right: 3.8rem;
            width: 6.3rem;
            height: 2.1rem;
        }

        .step2 {
            top: 2.8rem;
            right: 0.6rem;
            width: 5rem;
            height: 1.5rem;
        }

        .stepbtn {
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.75rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }

        .closeIt {
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
        }
    }
</style>


